import Api from '../../utils/api';
import {API_LEADERBOARD} from '../../configs/apis';
import {
  API_LEADERBOARD_FETCH,
  API_LEADERBOARD_SUCCESS,
  API_LEADERBOARD_ERROR,
} from '../types';

export function fetchLeaderboard(params) {
  return async (dispatch) => {
    try {
      const {appId, ...rest} = params;
      dispatch({type: API_LEADERBOARD_FETCH, ...params});
      const response = await Api.get(API_LEADERBOARD, rest, {appId});
      return dispatch({type: API_LEADERBOARD_SUCCESS, response});
    } catch (error) {
      return dispatch({type: API_LEADERBOARD_ERROR, error: error.message});
    }
  };
}
